import { css } from "@vitality-ds/system";
export default css({
  opacity: 1,
  "&:not(:last-child)": {
    marginRight: "$sm"
  },
  "@bp2": {
    opacity: 0
  }
});